import { Outlet } from 'react-router-dom';
import { useAuth } from './useAuth';
import { RoleGuard } from './RoleGuard';
import { ForbiddenPage } from '@/components/common/ForbiddenPage';

export function SuperAdminRoute() {
  const { role } = useAuth();
  return (
    <RoleGuard allowedRoles={['super_admin']} userRole={role} forbiddenFallback={<ForbiddenPage />}>
      <Outlet />
    </RoleGuard>
  );
}
